/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios, { baseURL } from "utils/api";
import { toast } from "react-toastify";

const useClassData = (handleDeleteClick, handleEditClick, refresh) => {
  const [rows, setRows] = useState([]);
  const [count, setcount] = useState(0);

  const columns = [
    { name: "sno", align: "center" },
    { name: "Class", align: "center" },
    { name: "action", align: "center" },
  ];

  useEffect(() => {
    axios
      .get(`${baseURL}/classes?limit=100`)
      .then((res) => {
        if (res.data.success) {
          const data = res.data.data;
          const activeClasses = data.filter((classItem) => !classItem.isDeleted);
          setcount(activeClasses.length);

          if (activeClasses.length === 0) {
            setRows([
              {
                sno: (
                  <ArgonTypography variant="caption" fontWeight="medium" color="text">
                    -
                  </ArgonTypography>
                ),
                Class: (
                  <ArgonTypography variant="caption" fontWeight="medium" color="error">
                    No data available. Please add a class.
                  </ArgonTypography>
                ),
                action: (
                  <ArgonTypography variant="caption" fontWeight="medium" color="text">
                    -
                  </ArgonTypography>
                ),
              },
            ]);
          } else {
            const formattedRows = activeClasses.map((item, index) => ({
              sno: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {index + 1}
                </ArgonTypography>
              ),
              Class: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {item.name}
                </ArgonTypography>
              ),
              action: (
                <ArgonBox display="flex" alignItems="center" gap={0}>
                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "12px", p: 0 }}
                    onClick={() => handleEditClick(item._id, item.name)}
                  >
                    <EditIcon color="warning" />
                  </ArgonButton>
                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "32px", p: 0 }}
                    onClick={() => handleDeleteClick(item._id)}
                  >
                    <DeleteIcon color="error" />
                  </ArgonButton>
                </ArgonBox>
              ),
            }));

            setRows(formattedRows);
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching classes:", err);
        const backendError = err.response?.data?.error;
        if (backendError) toast.error(backendError);
      });
  }, [refresh]);

  return { columns, rows, count };
};

export default useClassData;
